import config from 'Config'
import { getPage } from 'Utils'

export const generateQueryVars = (
  location,
  params,
  paginationSize = config.pagination.productList
) => {
  const queryString = location.search
  /* TODO: possible improvement - function to generate the regexes from array */
  const saleMatch = queryString.match(/sale=true/)
  const storeMatch = queryString.match(/store=(\d+)/g)
  const minPriceMatch = queryString.match(/min=(\d+)/)
  const maxPriceMatch = queryString.match(/max=(\d+)/)
  const sortMatcher = queryString.match(/sort=(\w+)/)
  const orderMatcher = queryString.match(/order=(\w+)/)
  const colorMatch = queryString.match(/color=(\w+)/g)

  let argumentsObject = {
    categoryUuid: params.uuid
  }

  const departmentMatch = queryString.match(/category=([^&]*)/)
  if (departmentMatch) {
    argumentsObject.department = decodeURIComponent(departmentMatch[1])
  }

  const term = queryString.match(/term/)
    ? queryString.match(/term=([^&]*)/)[1]
    : ''
  if (term) {
    argumentsObject.search = decodeURIComponent(term)
  }

  if (minPriceMatch) {
    argumentsObject.minPrice = minPriceMatch[1]
  }
  if (maxPriceMatch) {
    argumentsObject.maxPrice = maxPriceMatch[1]
  }
  if (storeMatch) {
    argumentsObject.storeIds = storeMatch.map(store =>
      parseInt(store.replace('store=', ''))
    )
  }
  if (saleMatch) {
    argumentsObject.sale = true
  }
  if (colorMatch) {
    argumentsObject.colors = colorMatch.map(color =>
      color.replace('color=', '')
    )
  }

  const sortObject = {}
  if (sortMatcher && sortMatcher[1] === 'price') {
    sortObject.price = orderMatcher[1] === 'asc'
  }
  if (!term) {
    sortObject.relevance = true
  }

  return {
    arguments: argumentsObject,
    pagination: {
      page: getPage(queryString),
      size: paginationSize
    },
    sort: sortObject
  }
}
